import React from "react";
import { Language } from "prism-react-renderer";
import { noop } from "lodash";
import Editor from "react-simple-code-editor";
import { pureHighligherFn } from "#common/PureHighlighter";
import { useTheme } from "@mui/material";

export type CodeEditorProps = {
    code: string;
    languageMode?: Language;
    onChange?: (value: string) => void;
};

export const CodeEditor = ({
    code,
    languageMode = "sql",
    onChange = noop,
}: CodeEditorProps) => {
    const [val, setValue] = React.useState<string>(code);
    const theme = useTheme();
    const onChangeCallback = React.useCallback(
        (value: string) => {
            setValue(value);
            onChange(value);
        },
        [onChange, val]
    );

    console.log("rendering");
    return (
        <Editor
            autoFocus
            value={val}
            onValueChange={code => onChangeCallback(code)}
            highlight={code => pureHighligherFn(code, languageMode)}
            style={{
                fontFamily: "monospace",
                backgroundColor: "initial",
                borderRadius: theme.shape.borderRadius,
                border: theme.palette.grey.A100,
            }}
        />
    );
};
